module.exports = __webpack_public_path__ + "static/media/duties.17140eec.webp";